import React from 'react';
import { ReactComponent as Chain } from '../../assets/images/icons/chain.svg';

export default function ChainIcon(props) {
  return (
    <Chain className={`icon ${props.className}`} />
  );
}
